// extracted by mini-css-extract-plugin
export var actionIcon = "_kg-0";